import "../../../chunks/server.js";
//#region src/routes/profile/+page.svelte
function _page($$renderer) {
	$$renderer.push(`<h1>Profile</h1>`);
}
//#endregion
export { _page as default };
